// extracted by mini-css-extract-plugin
module.exports = {"pricePanel":"PriceCard_pricePanel__pCLNM"};